import { useState } from 'react';
import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';

import { EntryData, Nullable } from 'chaika-frontend-types/frontend-cms';

import type { OptionType } from '@components/Select';
import { store } from '@store';
import { entryService } from '@patient/services/entry/entryService';

interface Params {
    entry: EntryData;
}

interface UseCoAuthorsForm {
    coAuthorIds: string[];
    canSave: boolean;
    onCoAuthorsSelect(options: Nullable<OptionType<string>[]>): void;
    onSave(): Promise<void>;
}

export function useCoAuthorsForm({ entry }: Params): UseCoAuthorsForm {
    const { app } = store;

    const entryCoAuthors = entry.coAuthorIds ?? [];

    const [coAuthorIds, setCoAuthorIds] = useState<string[]>(entryCoAuthors);

    const canSave = [difference(coAuthorIds, entryCoAuthors), difference(entryCoAuthors, coAuthorIds)].some(
        it => !isEmpty(it),
    );

    function onCoAuthorsSelect(options: Nullable<OptionType<string>[]>): void {
        const ids = (options ?? []).map(it => it.value);
        setCoAuthorIds(ids);
    }

    async function onSave(): Promise<void> {
        if (canSave) {
            await entryService.changeCoAuthors(coAuthorIds);
            app.resetRightMenu();
        }
    }

    return {
        coAuthorIds,
        canSave,
        onCoAuthorsSelect,
        onSave,
    };
}
